export const FETCHING_CINEMA_SHOWTIME = "FETCHING_CINEMA_SHOWTIME";
export const FETCHED_CINEMA_SHOWTIME = "FETCHED_CINEMA_SHOWTIME";
export const RECEIVED_CINEMA_SHOWTIME = "RECEIVED_CINEMA_SHOWTIME";
